'use client';

import { motion } from 'framer-motion';
import { Search, Globe, Code, Users } from 'lucide-react';

const SCAN_STEPS = [
  { icon: Globe, text: 'Discovering sitemap...', delay: 0 },
  { icon: Code, text: 'Analyzing technology stack...', delay: 0.6 },
  { icon: Search, text: 'Finding social profiles...', delay: 1.2 },
  { icon: Users, text: 'Identifying competitors...', delay: 1.8 },
];

export default function ScanAnimation({ domain, onComplete }) {
  return (
    <div className="flex flex-col items-center gap-8 py-8">
      {/* Scanning indicator */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="flex flex-col items-center gap-3"
      >
        <div className="relative">
          <motion.div
            className="h-16 w-16 rounded-full border-2 border-primary/30"
            animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.6, 0.3] }}
            transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
          />
          <motion.div
            className="absolute inset-0 flex items-center justify-center"
            animate={{ rotate: 360 }}
            transition={{ duration: 3, repeat: Infinity, ease: 'linear' }}
          >
            <div className="h-16 w-16 rounded-full border-2 border-transparent border-t-primary" />
          </motion.div>
        </div>
        <p className="text-lg font-semibold text-foreground">
          Scanning {domain || 'your site'}...
        </p>
      </motion.div>

      {/* Staggered log entries */}
      <div className="w-full max-w-sm space-y-3">
        {SCAN_STEPS.map(({ icon: Icon, text, delay }, i) => (
          <motion.div
            key={text}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay, duration: 0.4, ease: 'easeOut' }}
            onAnimationComplete={() => {
              if (i === SCAN_STEPS.length - 1 && onComplete) {
                setTimeout(onComplete, 800);
              }
            }}
            className="flex items-center gap-3 rounded-lg bg-card/40 px-4 py-2.5 backdrop-blur-sm"
          >
            <Icon className="h-4 w-4 text-primary" />
            <span className="text-sm text-muted-foreground">{text}</span>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: delay + 0.3 }}
              className="ml-auto"
            >
              <svg className="h-4 w-4 text-primary" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </motion.div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
